// extracted by mini-css-extract-plugin
export default {"wrapper":"Previous_wrapper__TC7z6"};